
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/battle-demo/solo-pve",
      function () {
        return require("private-next-pages/battle-demo/solo-pve.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/battle-demo/solo-pve"])
      });
    }
  